/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * smoothScrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * スムーススクロール
 */
const smoothScrollTo = () => {
	const anchorLinks = document.querySelectorAll('a[href^="#"]');
	const anchorLinksArr = Array.prototype.slice.call(anchorLinks);

	const scrollToElement = (targetElement) => {
		const lenis = window.lenis;

		if (lenis && typeof lenis.scrollTo === "function") {
			lenis.scrollTo(targetElement);
		} else {
			const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
			window.scrollTo({
				top: targetOffsetTop,
				behavior: "smooth",
			});
		}
	};

	// ページ読み込み時、URL にハッシュが含まれていればその位置までスクロール
	if (window.location.hash) {
		const initialTarget = document.querySelector(window.location.hash);
		if (initialTarget) {
			// レイアウト確定後にスクロールさせたいので少し待つ
			setTimeout(() => {
				scrollToElement(initialTarget);
			}, 50);
		}
	}

	anchorLinksArr.forEach((link) => {
		link.addEventListener("click", (e) => {
			// aタグのhrefからURLオブジェクトを生成
			const url = new URL(link.href, window.location.href);

			// 別ページへのリンク、もしくはハッシュがない場合は通常のリンク動作に任せる
			if (url.pathname !== window.location.pathname || !url.hash) {
				return;
			}

			const targetId = url.hash;
			const targetElement = document.querySelector(targetId);

			// 対象要素が存在しない場合も通常のリンク動作に任せる
			if (!targetElement) {
				return;
			}

			e.preventDefault();

			scrollToElement(targetElement);
		});
	});
};

export { smoothScrollTo };
